import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Query } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import Spin from 'components/common/Spin';
import { GET_ESSAY_PROMPTS, UPDATE_PROMPT } from 'graphql/essays';
import { PROMPTS_CATEGORIES } from 'constant/essay';
import { DragDropContext } from 'react-beautiful-dnd';
import { useMutation, useQuery } from '@apollo/react-hooks';
import useSnack from 'hooks/useSnack';
import Dialog from '@material-ui/core/Dialog';
import PromptsList from './PromptsList';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
  },
  text: {
    marginBottom: theme.spacing(3),
  },
  paperWidthLg: {
    maxWidth: 1100,
  },
}));

const Prompts = ({ student }) => {
  const snack = useSnack();
  const [updatePrompt] = useMutation(UPDATE_PROMPT);
  const queryParams = { userId: student.id };
  const { loading, error, data } = useQuery(GET_ESSAY_PROMPTS, {
    variables: queryParams,
  });

  const prompts = data ? data.essay_prompts : [];

  const onDragEnd = (result) => {
    const { source, destination, draggableId } = result;
    // dropped nowhere
    if (!destination) {
      return;
    }
    if (source.droppableId === destination.droppableId) {
      // reordering
      if (source.index === destination.index) {
        return;
      }
      // TODO update the order
    } else {
      const id = Number(draggableId);
      const prompt = prompts.find((i) => i.id === id);
      updatePrompt({
        variables: {
          id,
          input: {
            category_id: destination.droppableId,
          },
        },
        optimisticResponse: {
          __typename: 'Mutation',
          row: {
            ...prompt,
            category_id: destination.droppableId,
          },
        },
      }).then(
        () => {
          snack.success('Prompt Updated');
        },
        (e) => {
          snack.error(e.message);
        },
      );
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Query query={GET_ESSAY_PROMPTS} variables={{ userId: student.id }}>
        {({ data, loading }) => {
          if (loading)
            return <Spin spinning linear />;

          return (
            <Grid container alignItems="center" >
              {PROMPTS_CATEGORIES.map((i, idx) => (
                <Grid item xs={12} sm={12} md={12} key={i.id}>
                  <PromptsList
                    category={i}
                    index={idx}
                    student={student}
                    prompts={data.essay_prompts}
                  />
                </Grid>
              ))}
            </Grid>
          )
        }}
      </Query>
    </DragDropContext>
  );
};

export default Prompts;